// TODO user_actions_enum + add_user_popover.js was the precursor of FORM_ACTIONS_ENUM.JS and is currently only used for user management.
// In the future we'd preferably use something similar to form_actions_enum.js
// , but also migrate further to "react-hook-form" as used in the more recent custom_user_form...

export const UserActions = Object.freeze({
  EDIT_PROFILE_NAME: {
    action: "editProfileName",
    // There's a new type of validation in CustomUserForm.js, but it's not yet implemented for existing elements that use add_user_popover.js
    requiredValidationList: ["dataChanged", "name", "username"],
  },
  EDIT_PROFILE_PASSWORD: {
    action: "editProfilePassword",
    // There's a new type of validation in CustomUserForm.js, but it's not yet implemented for existing elements that use add_user_popover.js
    requiredValidationList: ["dataChanged", "currentPassword", "password", "confirmPassword"],
  },
  RESET_USER_PASSWORD: {
    action: "changePassword",
    // There's a new type of validation in CustomUserForm.js, but it's not yet implemented for existing elements that use add_user_popover.js
    requiredValidationList: ["dataChanged", "password", "confirmPassword"],
  },
  EDIT_USER: {
    action: "editUser",
    // There's a new type of validation in CustomUserForm.js, but it's not yet implemented for existing elements that use add_user_popover.js
    requiredValidationList: ["dataChanged", "username", "name", "company_name", "roles"],
  },
  ACTIVATE_DEACTIVATE_USER: {
    action: "activateDeactivateUser",
    // There's a new type of validation in CustomUserForm.js, but it's not yet implemented for existing elements that use add_user_popover.js
    requiredValidationList: [],
  },

  // TEMP RESET LINK ACTIONS
  RESET_PASSWORD_TEMP_LINK: {
    action: "resetPasswordTempLink",
    navigate: "/login",
    parseHeader: "Reset Password",
    // The validation happens via the newer CustomUserForm.js way
    //requiredValidationList: ['dataChanged', 'username', 'password', 'confirmPassword']
  },
  REQUEST_RESET_TEMP_LINK: {
    action: "requestResetTempLink",
    navigate: "/login",
    parseHeader: "Request Reset Password",
    // The validation happens via the newer CustomUserForm.js way
    //requiredValidationList: ['dataChanged']
  },
  ADD_USER: {
    action: "addUser",
    // There's a new type of validation in CustomUserForm.js, but it's not yet implemented for existing elements that use add_user_popover.js
    requiredValidationList: ["dataChanged", "username", "name", "roles", "company_name"],
  },
});
